import type { AnimalCollectionItem, InvestigationCollectionItem, LocationCollectionItem } from '@nuxt/content'

function groupByAnimal(
  animals: AnimalCollectionItem[],
  locations: LocationCollectionItem[],
): LocationGroup[] {
  return animals.map((animal) => {
    return {
      label: animal.plural,
      locations: locations.filter((location) => {
        return location.animals.includes(animal.key)
      }),
    }
  })
}

function groupByArticle(
  articles: InvestigationCollectionItem[],
  locations: LocationCollectionItem[],
): LocationGroup[] {
  return articles.map((article) => {
    return {
      label: article.title,
      locations: locations.filter((location) => {
        return location.path.match(article.path)
      }),
    }
  })
}

export default function (
  articles: Ref<InvestigationCollectionItem[]>,
  animals: Ref<AnimalCollectionItem[]>,
  locations: Ref<LocationCollectionItem[]>,
) {
  const groupBy = ref<LocationGroupType>('animal')

  const groupedLocationsUnfiltered = computed<LocationGroup[]>(() => {
    if (groupBy.value === 'animal')
      return groupByAnimal(animals.value, locations.value)

    if (groupBy.value === 'article')
      return groupByArticle(articles.value, locations.value)

    return [
      {
        label: 'All',
        locations: locations.value,
      },
    ]
  })

  const groupedLocations = computed<LocationGroup[]>(() => {
    return groupedLocationsUnfiltered.value.filter(group => group.locations.length > 0)
  })

  return {
    groupBy,
    groupedLocations,
  }
}
